import * as React from 'react'

import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

import type Employee from 'modules/employees/store/models/Employee'
import { Leaves } from 'modules/timeoff/store/collections/leaves'

// TODO: Check types after TS migration
// type Data = {
//   currentAndFutureLeaves: Leaves,
//   fetchData: Function,
//   fetchCount: number
// }
const leavesContext: React.Context<any> = React.createContext({})

const LeavesProvider = leavesContext.Provider

export const LeavesContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
  // FIXME Hack for
  // https://linear.app/factorial/issue/FRA-292/fix-issue-with-updated-leaves-not-being-reflected-in-calendar-current
  // Maybe Context is not the best way to keep the views on leaves in sync, see
  // https://github.com/factorialco/factorial-frontend/pull/4356#discussion_r559489527
  const fetchCount = React.useRef(0)
  const currentAndFutureLeaves = React.useRef(new Leaves()).current

  const fetchData = (employee: Employee) => {
    fetchCount.current += 1

    return currentAndFutureLeaves.fetch({
      data: {
        employee_id: employee.attributes.id,
        terminated: true,
        from: dateToString(moment([moment().year(), 0, 1]), 'backend'),
        include_all_pending_approvals: true,
      },
    })
  }

  const values = {
    currentAndFutureLeaves,
    fetchData,
    fetchCount: fetchCount.current,
  }

  return <LeavesProvider value={values}>{children}</LeavesProvider>
}

export const useLeaves = () => {
  const data = React.useContext(leavesContext)

  if (!data) {
    throw new Error('useLeaves must be used within a collection provider')
  }

  return data
}
